
<script>
import appConfig from "@/app.config";
import ItemsApi from "@/services/items-api";
import OrdersApi from "@/services/orders-api";
import Vue from 'vue'

export default {
  page: {
    title: "Page de paiement",
    meta: [{ name: "description", content: appConfig.description }]
  },
  data() {
    return {
      paymentOffreList: [],
      selectedForfaits: [],
      showPaymentModal: false,
      isSuccess:false,
      message:null,
      disabledPaymentButton: false,
    };
  },
  mounted() {
    this.findAnnuallyAbonnementOffer();
  },
  methods: {
    forfaitservices(ref) {
      switch (ref) {
        case "service 1":
          return [
            "Accès aux offres permanentes : offers disponibles durant toute l'année des conditions particulières d'achat",
            "Accès aux offres provisoires et groupées : commandes groupées entre tous les membres via la centrale d'achat du groupement"
          ];
        case "service 2":
          return [
            "Communication sur les promotions et les offres du mois de la pharmacie",
            "Affichage du planning d'animations",
            "Annonce de la semaine de garde",
            "Messages de sensibilisation",
          ];
        default:
          return [];
      }
    },

    forfaitTitle(ref) {
      switch (ref) {
        case "service 1": return "Service 1 : Accés à la platforme LGP";
        case "service 2": return "Service 2 : Accompagnement dans le merchandising";
        default: return "";
      }
    },
    
    forfaitDescription(ref) {
      switch (ref) {
        case "service 1": return "";
        case "service 2": return "Ce service comprend la création d'un contenu dynamique personnalisé mensuel et sa diffusion à distance";
        default: return "";
      }
    },
    toggleForfait(forfait) {
      const index = this.selectedForfaits.findIndex(
        f => f.id === forfait.id
      );

      if (index === -1) {
        this.selectedForfaits.push(forfait);
      } else {
        this.selectedForfaits.splice(index, 1);
      }
    },
    isSelected(forfaitId) {
      return this.selectedForfaits.some(
        f => f.id === forfaitId
      );
    },
    findAnnuallyAbonnementOffer() {
      ItemsApi.findAnnuallyAbonnementOffer()
        .then(result => { this.paymentOffreList = result; })
        .catch(err => console.error(err));
    },

    selectPaymentMethod(method) {
      this.disabledPaymentButton= true
      this.showPaymentModal = false;

      const forfaitIds = this.selectedForfaits.map(f => f.id);
      OrdersApi.postPayment(forfaitIds, method)
        .then(res => {
          if(res){
            Vue.prototype.$snotify.success(
              "Votre demande de paiement a été envoyée avec succès."
            );

            setTimeout(() => {
                            this.$router.push({ name: "default" });
                        }, 2000);
            }
        })
        .catch(() => {
          Vue.prototype.$snotify.error(
            "Une erreur est survenue lors du paiement. Veuillez réessayer."
          );
        });
    }


  },
  computed:{
    totalHT() {
      return this.selectedForfaits
        .reduce((total, f) => {
          const price = parseFloat(
            f.price.replace(',', '.')
          );
          return total + price;
        }, 0)
        .toFixed(3);
    }
  }
};
</script>


<template>
  <div>
    <!-- MESSAGE / STATUS -->
    <div v-if="message" class="row mt-4 pt-4 mb-4"> 
      <div class="col-lg-12 text-center">
        <p class="font-size-20 pt-2 mt-4" :class="isSuccess ? 'text-primary' : 'text-danger'">
          {{ message }}
        </p>

        <a v-if="!isSuccess" href="/payment" class="btn btn-danger text-uppercase mt-4">
          Retour à la page de paiement
        </a>
        <a v-else href="/" class="btn btn-primary text-uppercase font-weight-bold mt-4">
          Retour à la page d'accueil
        </a>
      </div>
    </div>

    <!-- MAIN CONTENT -->
    <div v-if="!message && !isSuccess" class="row mt-4 pt-4 mb-4">
      <!-- LEFT INFO COLUMN -->
      <div class="col-lg-12 pr-4 pl-4 mt-0"> 
        <img src="@/assets/images/logo.png" alt height="80" class="mb-4" />
        <h2 class="font-size-25 text-primary font-weight-bold text-uppercase" style="letter-spacing: 2px;">
          Forfaits Annuels LGP
        </h2>
        <p class="mt-4  font-size-18 text-primary">
          Le Groupement Pharmaceutique met à votre disposition les deux services suivants. Veuillez <strong>sélectionner le ou les services</strong> auxquels vous souhaitez adhérer :
        </p>
        <p class="font-size-14 mt-0 text-primary text-justify font-weight-bold">
          NB : L'accès à la plateforme sera interrompu le 31 janvier en cas de non renouvellement.
        </p>
        
      </div>

    <div class="col-lg-8 p-4 mt-4 pt-4">
      <div class="row">

        <div
          v-for="(forfait, index) in paymentOffreList"
          :key="index"
          class="col-12 my-2"
        >
          <div
            class="forfait-row"
            :class="{ selected: isSelected(forfait.id) }"
            @click="toggleForfait(forfait)"
          >
            <!-- LEFT -->
            <div class="forfait-info">
              <h4 class="forfait-title text-primary">
                <img
                  v-if="isSelected(forfait.id)"
                  src="@/assets/images/radio-button-on.svg"
                  height="20"
                  class="mr-2"
                />
                <img
                  v-else
                  src="@/assets/images/radio-button-off.svg"
                  height="20"
                  class="mr-2"
                />
                {{ forfaitTitle(forfait.ref) }}
              </h4>

              <p class="forfait-desc text-primary">
                {{ forfaitDescription(forfait.ref) }}
              </p>

              <ul class="forfait-services text-dark">
                <li
                  v-for="(service, idx) in forfaitservices(forfait.ref)"
                  :key="idx"
                >
                  {{ service }}
                </li>
              </ul>
            </div>

            <!-- RIGHT -->
            <div class="forfait-price">
              <span class="amount">
                {{ ((forfait.priceAsFloat / 12) * 1.19).toFixed(3) }}
              </span>
              <span class="period">DT / mois</span>
            </div>
          </div>
        </div>

      </div>
    </div>

     <div class="col-lg-4 p-4 mt-4 pt-4">
      



     <div class="summary-card d-flex flex-column h-100">

      <!-- TITLE -->
      <div class="summary-title text-primary">
        Demande de renouvellement annuel
      </div>

      <!-- EMPTY STATE -->
      <div
        v-if="selectedForfaits.length === 0"
        class="empty-state"
      >
        <i class="fas fa-info-circle mb-2"></i>
        <p>
          Aucun forfait sélectionné.<br>
          Veuillez sélectionner au moins un forfait.
        </p>
      </div>

      <!-- LISTE DES SERVICES -->
      <ul
        v-else
        class="summary-list"
      >
        <li
          v-for="forfait in selectedForfaits"
          :key="forfait.id"
        >
          <span class="service-title">
            <i class="fas fa-check-circle mr-2"></i>
            {{ forfaitTitle(forfait.ref) }}
          </span>
          <span class="service-price text-primary">
            {{ forfait.price }} HT
          </span>
        </li>
      </ul>

      <!-- TOTAL -->
      <div
        v-if="selectedForfaits.length > 0"
        class="summary-total mt-3"
      >
        <span class="text-uppercase text-primary">Total HT</span>
        <span class="total-price text-primary">{{ totalHT }} DT</span>
      </div>

      <!-- ACTION -->
      <b-button
        variant="primary"
        size="md"
        class="font-size-16 mt-auto mx-auto action-btn w-100"
        :disabled="selectedForfaits.length === 0"
        @click="showPaymentModal = true ; disabledPaymentButton = false;"
      >
        Confirmer la sélection et continuer
      </b-button>

    </div>




     </div>




    </div>

    <!-- PAYMENT MODAL -->
    <b-modal
      v-model="showPaymentModal"
      centered
      size="md"
      hide-footer
      hide-header
      modal-class="payment-modal"
    >



      <div class="payment-modal-content">


       
        <!-- TITLE -->
         <div class="row">
            <div class="col-10">
              <h4 class="payment-title text-primary">
                Confirmation de la demande
              </h4>
            </div>
            <div class="col-2 text-right text-danger font-weight-bold" style="cursor:pointer;">
              <div @click="showPaymentModal = false">
                <img src="@/assets/images/close-sm.svg" height="20" class="mr-2"/>
              </div>
            </div>
         </div>
       

        <p class="payment-subtitle text-dark">
          Vous êtes sur le point de soumettre une demande de renouvellement
          pour les services suivants :
        </p>

        <!-- FORFAITS LIST -->
        <ul class="payment-list">
          <li
            v-for="forfait in selectedForfaits"
            :key="forfait.id"
          >
            <span class="">{{ forfaitTitle(forfait.ref) }}</span>
            <span class="price font-weight-bold text-dark">{{ forfait.price }} HT</span>
          </li>
        </ul>

        <!-- TOTAL -->
        <div class="payment-total text-dark mt-4">
          <span>Total HT</span>
          <span>{{ totalHT }} DT</span>
        </div>

        <!-- PAYMENT METHOD -->
        <div class="payment-methods mt-5">
          <p class="method-title text-primary">
            Veuillez choisir le mode de paiement pour valider votre demande :
          </p>

          <div class="method-buttons mt-4">
            <b-button variant="outline-primary"
              @click="selectPaymentMethod(2)" class="mr-2" style="letter-spacing: 1px;"
              :disabled="disabledPaymentButton"
            >
              Valider la demande et payer <strong>par chèque</strong>
            </b-button>

            <b-button variant="outline-primary"
              @click="selectPaymentMethod(1)" class="ml-2" style="letter-spacing: 1px;"
              :disabled="disabledPaymentButton"
            >
              Valider la demande et payer <strong>par virement</strong>
            </b-button>
          </div>
        </div>

       

      </div>
    </b-modal>

  </div>
</template>

<style scoped>
.forfait-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 26px 32px;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.25s ease;
  border: 1px solid #f0f0f0;
}

.forfait-row.selected {
  border-color: #1e1e2d;
  background-color: #8baecf28;
}

/* LEFT */
.forfait-info {
  max-width: 70%;
}

.forfait-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: #1e2d2a;
  margin-bottom: 6px;
  line-height: 1.2;
}

.forfait-desc {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 14px;
}

.forfait-services {
  padding-left: 0;
  margin: 0;
  list-style: none;
}

.forfait-services li {
  font-size: 14px;
  color: #374151;
  margin-bottom: 6px;
  position: relative;
  padding-left: 25px;
}

.forfait-services li::before {
  content: "\f00c"; 
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  position: absolute;
  left: 0;
  color: #297a54;
  font-size: 12px;
  top: 3px;
}

/* RIGHT */
.forfait-price {
  text-align: right;
}

.amount {
  font-size: 34px;
  font-weight: 700;
  color: #297a54;
}

.period {
  display: block;
  font-size: 13px;
  color: #6b7280;
}

.summary-card {
  border: 1px solid #1f3a56;
  border-radius: 8px;
  padding: 24px 16px;
  background: #fff;
  height: 100%;
  transition: all 0.3s ease;
}


.summary-title {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 18px;
}

/* EMPTY STATE */
.empty-state {
  text-align: center;
  color: #6b7280;
  padding: 30px 15px;
}

.empty-state i {
  font-size: 26px;
  color: #297a54;
}

.empty-state p {
  font-size: 14px;
  margin: 0;
}

/* LIST */
.summary-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.summary-list li {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px 0;
  border-bottom: 1px solid #f1f1f1;
}

.service-title {
  font-size: 14px;
  color: #1e2d2a;
  display: flex;
  align-items: center;
}

.service-title i {
  color: #297a54;
  font-size: 14px;
}

.service-price {
  font-size: 14px;
  font-weight: 600;
}

/* TOTAL */
.summary-total {
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  font-weight: 700;
  margin: 18px 0;
}

/* BUTTON */
.action-btn {
  border-radius: 10px;
 
}
</style>



<style>

.payment-modal .modal-content {
  border-radius: 18px;
  padding: 28px;
}

.payment-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e2d2a;
  margin-bottom: 8px;
}

.payment-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 20px;
}

/* LIST */
.payment-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.payment-list li {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.payment-list .price {
  font-weight: 600;
  color: #297a54;
}

/* TOTAL */
.payment-total {
  display: flex;
  justify-content: space-between;
  font-weight: 700;
  margin: 16px 0;
  font-size: 16px;
}

/* METHODS */
.payment-methods {
  margin-top: 20px;
}

.method-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
}

.method-buttons {
  display: flex;
  gap: 10px;
}

.method-btn {
  flex: 1;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #297a54;
  background: white;
  color: #297a54;
  transition: all 0.2s ease;
}

.method-btn:hover {
  background: #297a54;
  color: white;
}

/* ACTIONS */
.modal-actions {
  text-align: right;
  margin-top: 24px;
}

.btn-cancel {
  background: transparent;
  border: none;
  color: #6b7280;
  font-weight: 600;
  cursor: pointer;
}

/* ===================== */
/* RESPONSIVE - MOBILE   */
/* ===================== */
@media (max-width: 567px) {

  .forfait-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .forfait-info {
    max-width: 100% !important;
  }

  .forfait-price {
    width: 100%;
    margin-top: 12px;
    text-align: left;
  }

  .amount {
    font-size: 26px;
  }

  .period {
    display: inline-block;
    margin-left: 6px;
  }

}

</style>